export const getActiveKey = (pathname: string) => {
  return `/${pathname.split('/').at(1) ?? ''}`;
};
